import React, { useEffect } from 'react';
import styles from './Portada.module.css';

export const HeroSlideshow = ({ slides, activeIndex, setActiveIndex }) => {
  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 5000); // 5s interval

    return () => clearInterval(timer);
  }, [slides.length, setActiveIndex]);

  return (
    <div className={styles.slideshowContainer}>
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`${styles.slide} ${index === activeIndex ? styles.active : ''}`}
          style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.65)), url(${slide.image})` }}
          aria-hidden={index !== activeIndex}
        />
      ))}
      
      {/* Slider indicators */}
      <div className={styles.indicators}>
        {slides.map((_, index) => (
          <button
            key={index}
            className={`${styles.indicatorDot} ${index === activeIndex ? styles.activeDot : ''}`}
            onClick={() => setActiveIndex(index)}
            aria-label={`Ir al slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};
export default HeroSlideshow;
